<template>
<div class='geo-coverage-indicator'>
  <div class='geo-coverage-indicator__percentile' :style="`--coverage-percentile-color: ${valueToResult.color};`"> {{ valueToResult.result }}%</div>
  <div class='geo-coverage-indicator__flag'>
    <div v-if="code === ''" style="width: 30px;" />
    <country-flag v-else
      rounded
      :country='code'
      size='normal' />
  </div>
  <div class='geo-coverage-indicator__content'>
    <div class='geo-coverage-indicator__content__country' :class="{'geo-coverage-indicator-selected':isSelected}">{{ country }}</div>
    <div class='geo-coverage-indicator__content__data'> {{ covered }} / {{ total }} </div>
  </div>
</div>
</template>

<script>
import { advancedRound } from '@/utils/numberUtils';
import CountryFlag from 'vue-country-flag';

export default {
  name: 'GEOCoverageIndicator',
  components: { CountryFlag },
  props: {
    total: {
      type: Number,
      required: true,
      default: () => 0,
    },
    covered: {
      type: Number,
      required: true,
      default: () => 0,
    },
    country: {
      type: String,
      required: true,
      default: () => '',
    },
    code: {
      type: String,
      required: true,
      default: () => '',
    },
    selected: {
      type: String,
      required: false,
      default: () => '',
    },
    colors: {
      type: Array,
      default() {
        return [
          {
            color: '#29CE9C',
          },
          {
            color: '#F0BF16',
          },
          {
            color: '#FBA212',
          },
          {
            color: '#FF7A03',
          },
          {
            color: '#ED3D68',
          },
          {
            color: '#E132A0',
          },
        ];
      },
    },
  },
  computed: {
    valueToResult() {
      const sectionsLength = 100 / (this.colors.length - 1);
      const percentile = (this.covered / this.total) * 100;
      const index = percentile / sectionsLength;
      let {color} = this.colors[this.colors.length - Math.ceil(index) - 1];
      if (this.value >= 90 && this.value <= 100) {
        color = this.colors[0].color;
      }
      return {
        result: advancedRound(percentile),
        color,
      };
    },
    isSelected() {
      return this.selected.toLowerCase() === this.country.toLowerCase();
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.geo-coverage-indicator-selected{
  font-family: $font-family-bold;
  font-size: $font-size-lg;
  color: var(--text-primary);
}
.geo-coverage-indicator{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: $space-2;
  &__percentile{
    font-family: $font-family-black;
    font-size: $font-size-3xl;
    text-transform: uppercase;
    color: var(--coverage-percentile-color);
    min-width: rem(100);
    padding-right: $space-2;
  }
  &__flag {
    padding-right: $space-2;
  }
  &__content{
    display: flex;
    flex-direction: column;
    &__country{
      color: var(--text-primary);
      display: flex;
      font-family: $font-family-semibold;
      font-size: $font-size-base;
      letter-spacing: 0;
      line-height: rem(17);
    }
    &__data{
      color: var(--text-primary);
      font-family: $font-family-regular;
      font-size: $font-size-sm;
      letter-spacing: 0;
      line-height: $space-4;
    }
  }
}
</style>
